import types from 'app/constants/sockets'
import { getIdentityAccessToken } from 'store/entities/identity/selectors'

const addSubscribers = (store, client) => {
  types.forEach(type => {
    client.on(type, data =>
      store.dispatch({
        payload: {
          ...(typeof data === 'string' ? JSON.parse(data) : data),
        },
        type,
      })
    )
  })
}

export default socket => store => next => action => {
  const prevState = store.getState()
  const nextAction = next(action)
  const nextState = store.getState()
  const prevToken = getIdentityAccessToken(prevState)
  const nextToken = getIdentityAccessToken(nextState)
  if (typeof nextToken === 'string') {
    if (nextToken === prevToken) {
      if (!socket.connected) {
        socket.connect(nextToken, client => addSubscribers(store, client))
      }
    } else {
      if (socket.connected) {
        socket.connect(nextToken, client => addSubscribers(store, client))
      }
    }
  } else {
    socket.disconnect()
  }
  return nextAction
}
